/**
 * LoadingScreen Component
 *
 * Full-screen loading indicator used during auth initialization and route transitions.
 * Uses the branded SplashScreen for consistent loading experience.
 */

import { SplashScreen } from '@/shared/components/SplashScreen';

export function LoadingScreen() {
  return <SplashScreen />;
}
